export class AnimalInfo {
    constructor(
        public animalName: string,
        public countryName: string,
        public isFavoriteAnimal: boolean,
        public animalClass: string,
        public product: string
    )
        {

        }
}
